module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.5a3339e.woff2";